import PropTypes from 'prop-types';

const AddOn = PropTypes.shape({
  available_inventory: PropTypes.shape({
    date: PropTypes.string,
    quantity: PropTypes.number,
  }),
  daily_limit: PropTypes.number,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
  item_id: PropTypes.number.isRequired,
  item_token: PropTypes.string,
  name: PropTypes.string.isRequired,
  price: PropTypes.number,
  sort_order: PropTypes.number,
  special: PropTypes.bool,
  total_quantity: PropTypes.number,
});

export default AddOn;
